import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import { validate } from 'graphql';

export interface DialogContractorReviewData {
  contractorName: string;
  contractorid: string;
  applicationid: string;
  review: string;
  reviewid?: string;
  response:string;
  responseDate?:Date;
}
@Component({
  selector: 'ebb-portal-dialog-contractorreview',
  templateUrl: './dialog-contractorreview.component.html'
})
export class DialogContractorReviewComponent implements OnInit {
  @Input('name') name = this.data.contractorName;
  public formContractorReview: FormGroup;

  public disableContractorReviewSave = true;
  public showContractorResponse = false;
  constructor(
    public dialogRef: MatDialogRef<DialogContractorReviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContractorReviewData,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.initializeNaming();
  }
  private initializeNaming(): void {
    this.formContractorReview.get('review').setValue(this.data.review);
    if(this.data.response !== null && this.data.response.length>0){

      this.formContractorReview.get('response').setValue(this.data.response);
      
      this.showContractorResponse = true;
      this.disableContractorReviewSave = true;
    }
    
  }
  private initializeForm(): void {
    this.formContractorReview = this.fb.group({
      review: ['', Validators.required],
      response: ['']
    });
  }
  public ebbContractorReviewInputChange(event: any): void {
 
      this.disableContractorReviewSave = false;
  
   
  }
public Reviewreadonly():Boolean{
  if(this.showContractorResponse === true){
    return true;
  }
  return false;
}
  public DisableSave():Boolean{

if(this.showContractorResponse === true){
  return true;
}
if(this.formContractorReview.pristine || this.formContractorReview.invalid ){
  return true;
}
return false;
  }
  public onSave(): void {
    this.data.review = this.formContractorReview.get('review').value;
    this.dialogRef.close(this.data);
  }
  public onClickCancel(): void {
    this.dialogRef.close();
  }
}
